import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { proApi, eurNum, imgSrc } from "@/lib/proApi";

export const useProProducts = () => {
  const [products, setProducts] = useState(null);
  useEffect(() => { proApi.get("/pro/products").then(({ data }) => setProducts(data)).catch(() => setProducts([])); }, []);
  return products;
};

export const ProductTile = ({ p }) => (
  <Link to={`/espace-pro/produit/${p.slug}`} data-testid={`home-product-${p.slug}`}
    className="group block h-full rounded-2xl bg-white border border-[var(--oz-border)] overflow-hidden hover:border-[var(--oz-gold)] transition-colors">
    <div className="aspect-square bg-[var(--oz-bg-2)] overflow-hidden">
      <img src={imgSrc(p.image)} alt={`${p.name} — produit professionnel Ozentya`} loading="lazy" width="400" height="400"
        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
    </div>
    <div className="p-4">
      <p className="text-[10px] uppercase tracking-[0.14em] text-[var(--oz-gold)] font-semibold">{p.category}</p>
      <p className="mt-1 font-semibold text-sm text-[var(--oz-text)] leading-snug">{p.name}</p>
      <p className="mt-1 text-xs text-[var(--oz-muted)]">Par {p.pack_sizes.join(" ou ")} pièces</p>
      <p className="mt-2 text-sm">
        {p.unit_price_ht != null
          ? <><b>{eurNum(p.unit_price_ht)}</b> <span className="text-xs text-[var(--oz-muted)]">HT / pièce</span></>
          : <span className="inline-flex items-center gap-1 text-xs text-[var(--oz-muted)]"><Lock className="w-3 h-3" /> Prix pro après connexion</span>}
      </p>
    </div>
  </Link>
);

export const CtaButtons = ({ dark = false, secondary = { to: "/espace-pro", label: "Découvrir les produits" }, testid = "cta" }) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <Link to="/espace-pro/inscription" data-testid={`${testid}-register`}
      className="group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--oz-gold)] text-[var(--oz-dark)] px-7 py-4 text-sm font-bold tracking-wide hover:bg-[var(--oz-gold-hover)] transition-colors">
      Créer mon compte professionnel <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
    </Link>
    {secondary && <Link to={secondary.to} data-testid={`${testid}-secondary`}
      className={`inline-flex items-center justify-center rounded-full px-7 py-4 text-sm font-semibold border transition-colors ${dark ? "border-white/30 text-white hover:border-[var(--oz-gold)]" : "border-[var(--oz-text)] text-[var(--oz-text)] hover:bg-[var(--oz-text)] hover:text-white"}`}>
      {secondary.label}
    </Link>}
  </div>
);
